exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hec-saving[data-v-8b5db812] {\n    margin-bottom: 20px!important;\n}\n", ""]);

// exports
